import { createSelector } from 'reselect'

/**
 * Update data in the current item
 */

const updateData = ({
  currentData,
  typeId,
  currentItemNewData,
  otherItemsNewData,
}) =>
  currentData.map(documentData =>
    documentData.id === typeId
      ? { ...documentData, ...currentItemNewData }
      : { ...documentData, ...otherItemsNewData },
  )

/**
 * Gets all documents types
 * And filter them on the current country
 */

const filterDocumentTypesInThisCountrySelector = () =>
  createSelector(
    state => state.document.documentTypesList,
    (_, countryCode) => countryCode,
    (documentTypesList, countryCode) =>
      documentTypesList.filter(
        documentType => documentType.countryCode === countryCode,
      ),
  )

/**
 * Gets all ambassador documents
 * And format them to [id]: preview document
 */

const ambassadorDocumentsPreviewSelector = () =>
  createSelector(
    state => state.ambassadors.ambassadorDocumentsById,
    ambassadorDocument =>
      ambassadorDocument.reduce((acc, ambassadorDocument) => {
        acc[ambassadorDocument.type.id] = ambassadorDocument.url
        return acc
      }, {}),
  )

export {
  updateData,
  filterDocumentTypesInThisCountrySelector,
  ambassadorDocumentsPreviewSelector,
}
